export const baseUrl = 'https://restcountries.com/v2/';

export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';